import { render, staticRenderFns } from "./ReferralConfirm.vue?vue&type=template&id=498b544f&scoped=true"
import script from "./ReferralConfirm.vue?vue&type=script&lang=js"
export * from "./ReferralConfirm.vue?vue&type=script&lang=js"
import style0 from "./ReferralConfirm.vue?vue&type=style&index=0&id=498b544f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b544f",
  null
  
)

export default component.exports